/* eslint-disable no-unused-vars */
import { apolloClient } from "@/setup/apollo-setup";
import axios from "axios";

import * as generic from "@/store/generic/mutations/result-status.js";

// import { getCourseOutlineById } from "@/services/api/course-outline";

import {
    // GET_COURSEOUTLINEREGISTRATION_BYID,
    // GET_STUDENTENROLLDETAIL_LIST,
    // GET_STUDENTENROLLDETAIL_LIST_BYFILTER,
    GET_STUDENTENROLLDETAIL_LIST_BYSTUDENTENROLLID,
    // GET_COURSEOUTLINEREGISTRATION_BYFILTER,
    // ADD_COURSEOUTLINEREGISTRATION,
    // UPDATE_COURSEOUTLINEREGISTRATION,
    // DELETE_COURSEOUTLINEREGISTRATION
} from '@/queries/modules/student-enroll/student-enroll-detail.js';

const state = {};

const getters = {};

const mutations = {};

const actions = {

/**
  *  Action to Get Student Enroll List
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

  // async getStudentEnrollDetailListByStudentEnrollId({ commit }, payload) {
  //   // commit('setProcessing', true);
  //   // console.log("id", payload)
  //   try {
  //     const result = await apolloClient
  //     .query({
  //       query: GET_STUDENTENROLLDETAIL_LIST_BYSTUDENTENROLLID,
  //       variables: payload,
  //       fetchPolicy: 'network-only',
  //       context: { clientName: 'Prisma2' }
  //     })
  //     //studentEnrollDetailFilterInput
  //     const { data } = await result;

  //     // TODO: Handle after success;
  //     return { status: { success: true, error: false, message: "" }, data: [ ...data.getStudentEnrollDetailsByStudentEnrollId ] };

  //   } catch (e) {
  //     // console.log(e);
  //     // commit('setError', error(e));
  //     return { status: { success: false, error: true, message: "", full: e }};
  //   }
  // },


/**
  *  Action to Add Course Outline Registration
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  *   @param  {Object} payload Contain requires inputs for adding data
  *     @property {CourseOutlineRegistrationInput (Array), required} courseOutlineRegistrationInput : [{
          academicPeriodId: "", // {String} Get it from filter selection.
          periodCode: "",       // {String} Get it from filter selection.
          degreeId: "",         // {String} Get it from filter selection.
          subjectGroupId: "",   // {String} Get it from filter selection.
          subjectId: "",        // {String} Get it from Course Outline Selection.
          subjectCode: "",      // {String} "----------------------------------"
          subjectName: "",      // {String} "----------------------------------"
          courseOutlineId: "",  // {String} "----------------------------------"
          teacherId: "",        // {String} "----------------------------------"
          teacherCode: "",      // {String} "----------------------------------"
        }]
  *
  */

//   async addCourseOutlineRegistration({ commit }, payload) {
//     // commit('setProcessing', true);
//     try {
//       const result = await apolloClient
//       .mutate({
//         mutation: ADD_COURSEOUTLINEREGISTRATION,
//         variables: payload
//       })
//       const { data } = await result;

//       return {
//         status: { success: true, error: false, message: "",
//         data: [ ...data.addCourseOutlineRegistration ] }
//       };

//     } catch (e) {
//       console.log(e);
//       // commit('setError', error(e));
//       return { status: { success: false, error: true, message: "", full: e }}
//     }
//   },


  /**
    *  Action to Delete Course Outline Registration
    *
    *   @param  {Object} context Vuex context object.
    *     @property {Vuex method (Function)} commit : "To commit a mutation"
    *
    *   @param  {Object} payload Contain requires inputs for adding data
    *     @property {ID (String), required} id : "ID of a Course Outline Registration"
    *
    */

//   async deleteCourseOutlineRegistration({ commit }, payload) {
//     // commit('setProcessing', true);
//     console.log(payload);
//     try {
//       const result = await apolloClient
//       .mutate({
//         mutation: DELETE_COURSEOUTLINEREGISTRATION,
//         variables: payload
//       })
//       const { data } = await result;
//       console.log(data);
//     //   const data = await getCourseOutlineById(payload);
//         // TODO: Handle after success;
//     //   return data;
//     } catch (e) {
//       console.log(e);
//       // commit('setError', error(e));
//       return { status: { success: false, error: true, message: "", full: e }}
//     }
//   },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
